<template>
  <div>
    <CreateUserButton/>
    <UserSearch/>
    <UserTable/>
  </div>
</template>

<script>
import  CreateUserButton  from '@/components/backend/user/CreateUserButton.vue'
import  UserSearch  from '@/components/backend/user/UserSearch.vue'
import  UserTable from '@/components/backend/user/UserResults.vue'

export default {
  name: 'UsersView',
  components: {
    CreateUserButton,
    UserSearch,
    UserTable
    
  }
}
</script>

<style scoped>

</style>
